import React from "react";
import { Archive } from "@mui/icons-material";
import { Button, Divider, ListItemIcon, MenuItem } from "@mui/material";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import ArquivadasTable from "./ArquivadasTable";
import Service from "../../../util/Service";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function ArquivadasDialog(props) {
    const { kanban, action } = props;

    const [open, setOpen] = React.useState(false);
    const [updateKanban, setUpdateKanban] = React.useState(false);
    const [arquivadas, setArquivadas] = React.useState([]);

    React.useEffect(() =>{
        if( open){
            Service.GET("/api/security/projeto/kanban/buscaArquivadasById/"+kanban.id).then( r=>{
                console.log( r );
                setArquivadas(r);
            })
        }
    }, [open])

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        console.log('>>handleClose<<')
        setOpen(false);
        if( updateKanban && action ) action();
    };

    // function handleClick(){
    //     if( action ) action();
    // }

    return (
        <React.Fragment>
            <Button
                startIcon={<Archive />}
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClickOpen}
                size='small'
            >
                Arquivadas
            </Button>
            <BootstrapDialog
                maxWidth='xl'
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Arquivadas
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <ArquivadasTable 
                        dadosRoot={arquivadas} 
                        kanban={kanban} 
                        setUpdateKanban={setUpdateKanban}
                    />
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose}>
                        Sair
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>

    )
}